import React from 'react';
import { useTranslation } from 'react-i18next';
import RadioButton from '@/components/common/RadioButton/RadioButton';
import { FormGroupProps } from './types';
import ReadOnlyField from '../../../common/ReadOnlyField/ReadOnlyField';

type Props = FormGroupProps & {
  yesOption: string;
  noOption: string;
  handleRadioButton: (field: string, value: any) => void;
};

export default function IngroovesCanadaRightsFormGroup({
  album,
  readonly,
  disabled,
  yesOption,
  noOption,
  handleRadioButton,
}: Props) {
  const { t } = useTranslation();

  return (
    <>
      {!readonly ? (
        <div className="form-group">
          <label
            htmlFor="ingroovesCanadaRights"
            className="col-sm-3 form-label"
          >
            {t('product.editProduct.ingroovesCanadaRights')}
          </label>
          <div className="col-sm-3">
            <RadioButton
              options={[yesOption, noOption]}
              selectedOption={
                album.albumMetaData?.manufacturing?.ingroovesCanadaRight
                  ? yesOption
                  : noOption
              }
              id="ingroovesCanadaRight"
              name="ingroovesCanadaRight"
              className="leftPadding"
              labelClass="leftPadding"
              onOptionChange={(e: any) => {
                handleRadioButton('ingroovesCanadaRight', e);
              }}
              disabled={disabled}
            ></RadioButton>
          </div>
        </div>
      ) : (
        <ReadOnlyField
          id={'ingroovesCanadaRight'}
          labelTitle={t('product.editProduct.ingroovesCanadaRights')}
          value={
            album.albumMetaData?.manufacturing?.ingroovesCanadaRight
              ? yesOption
              : noOption
          }
        ></ReadOnlyField>
      )}
    </>
  );
}
